export default "//yastatic.net/s3/distribution/pythia/frontend/_/f636eb36448944c0d1601b84986b371c.png";